import { eTipoPermissao } from "@/enums/ePermissoes";

export default [
 {
  description: "Prestação de Contas",
  path: "/prestacaocontas/pcoprojetoprestacaocontas",
  name: "pcoprojetoprestacaocontas",
  component: () => import("@/views/prestacaocontas/pcoprojetoprestacaocontas/Index.vue"),
  meta: {
   permissions: [eTipoPermissao.PRESTACAODECONTASNOVO_MENU_1500100499],
  },
  goesToMenu: true,
 },
 {
  description: "Cadastro de Prestação de Contas",
  path: "/prestacaocontas/pcoprojetoprestacaocontas/cadastro/:id?",
  parent: "pcoprojetoprestacaocontas",
  name: "pcoprojetoprestacaocontas_create",
  component: () => import("@/views/prestacaocontas/pcoprojetoprestacaocontas/InclusaoEdicao.vue"),
  meta: {
   permissions: [eTipoPermissao.PRESTACAODECONTASNOVO_MENU_1500100499],
  },
  goesToMenu: true,
 },
]
